<div class="container">
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    <!-- Footer Section -->
    <footer class="footer">
        <p>&copy; 2025 Kiko VPN. All rights reserved.</p>
        <p><a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of service</a></p>
        <!-- <div class="social-icons">
            <a href="https://www.facebook.com/KikoVPN" target="_blank">
              <img src="assets/icons/icon_facebook.png" alt="Facebook" />
            </a>
            <a href="https://twitter.com/KikoVPN" target="_blank">
              <img src="assets/icons/icon_twitter.png" alt="Twitter" />
            </a>
            <a href="https://www.instagram.com/KikoVPN" target="_blank">
              <img src="assets/icons/icon_instagram.png" alt="Instagram" />
            </a>
            <a href="https://www.linkedin.com/company/KikoVPN" target="_blank">
              <img src="assets/icons/icon_youtube.png" alt="Youtube" />
            </a>
        </div> -->
    </footer>
</div>


